import { Injectable } from '@angular/core';
import { BehaviorSubject, filter, fromEvent, interval, shareReplay, take, takeUntil, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BrowserService {
  openWindow(url: string, target: '_self' | '_blank' | '_system') {
    const openedWindow = window.open(url, target);

    if (!openedWindow) {
      throw new Error('Failed to open window.');
    }

    // Observable for when the window is closed
    const closed$ = interval(500).pipe(
      tap(x => console.log('closed: %o', openedWindow.closed)),
      filter(() => openedWindow.closed),
      take(1),
      shareReplay()
    );

    const message$ = fromEvent<MessageEvent>(window, 'message')
      .pipe(
        takeUntil(closed$),
        tap(x => console.log('received message %o', x)),
        filter(x => x.source === openedWindow)
      );

    return {
      closed$,
      message$,
      url$: new BehaviorSubject(url),
      close: () => openedWindow.close()
    };
  }
}
